// const new_service_basis = window.gtaAiConfig.service_basis
// const service_data = window.gtaAiConfig.service_data;
 /* eslint-disable */ 
 let tag= process.env.VUE_APP_TAG
 let new_service_basis=getEnv(tag).service_basis
 let service_data=getEnv(tag).service_data

export default {
    // 用户管理接口
    /**
     * 查看用户详情
     */
    getUserInfo: `${new_service_basis}/ai/training/user/getUserInfo`,
    /**
     * 修改用户详情
     */
    updateUserInfo: `${new_service_basis}/ai/training/user/updateUserInfo`,
    /**
     * 存头像路徑
     */
    uploadUserPhoto: `${new_service_basis}/ai/training/user/uploadUserPhoto`,
    /**
     * UC平台上传头像
     */
    UploadImage: `${service_data}/uc/userloginandreg/uploadImagesFile`,
    /**
     * 修改用户密码
     */
    updatePassword: `${new_service_basis}/ai/training/user/updatePassword`,
    /**
     * 发送验证码
     */
    sendMobileCode: `${new_service_basis}/ai/training/user/sendMobileCode`,
    /**
     * 绑定手机号
     */
    bindMobilePhone: `${new_service_basis}/ai/training/user/bindMobilePhone`,
    /**
     * 绑定邮箱
     */
    bindEmail: `${new_service_basis}/ai/training/user/bindEmail`
};
